import { ControlStateOptions } from "./ControlStateOptions"

/**
 *  Determine the CSS class for the outline of a control element.
 */
export function determineControlOutlineClass(state: ControlStateOptions) {
  if (state.readOnly) {
    return "outline-none ring-0 focus:ring-0"
  }

  if (state.error) {
    return "ring-red-500"
  }

  return "outline-none ring-0 focus:ring-0"
}
